import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const MonthlyPerformanceChart = ({ data = [] }) => {
  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: "Monthly Performance",
        data: data.map((item) => item.amount),
        borderColor: "#2AF598",
        backgroundColor: "rgba(42, 245, 152, 0.12)",
        fill: true,
        tension: 0.35,
        pointBackgroundColor: data.map((item) => (item.amount >= 0 ? "#2AF598" : "#F52A2D")),
        pointBorderColor: data.map((item) => (item.amount >= 0 ? "#2AF598" : "#F52A2D")),
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        labels: { color: "#fff", usePointStyle: true, padding: 16 },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.86)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#2AF598",
        borderWidth: 1,
        callbacks: {
          label: (context) => `Performance: ${Number(context.parsed.y || 0).toFixed(2)}%`,
        },
      },
    },
    scales: {
      x: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", maxRotation: 45, minRotation: 0 },
      },
      y: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", callback: (value) => `${value}%` },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default MonthlyPerformanceChart;
